module.exports = ".page-banner {\r\n    background: aqua\r\n}"